import { render } from "./DropBox.vue?vue&type=template&id=e4010eba"
import script from "./DropBox.vue?vue&type=script&lang=js"
export * from "./DropBox.vue?vue&type=script&lang=js"

import "./DropBox.vue?vue&type=style&index=0&id=e4010eba&lang=css"

import exportComponent from "/home/merlyn/Working/bili-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__